<mat-card-title>Zoning Allowance</mat-card-title>
<app-object-to-table [source]="data" [dictionary]="zoningAllowanceDictionary" [showEmptyFields]="false"></app-object-to-table>